import {ApplicationRef, enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowserDynamic}         from '@angular/platform-browser-dynamic';
import {AppModule}                      from './app/app.module';
import {environment}                    from './environments/environment';
import {enableDebugTools}               from '@angular/platform-browser';
import './app/debug-utils/ApplicationTracer';

if (environment.Production) {
  enableProdMode();
} else {
  window['mapFunctions'] = {};
}

if (typeof window.crypto.randomUUID !== 'function') {
  // fix crypto uuid generate function if we run in an insecure context otherwise the function is not available
  window.crypto.randomUUID = () => Math.random().toString(36).substring(2, 15) as `${string}-${string}-${string}-${string}-${string}`;
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .then(moduleRef => {
    if (window.location.host === '127.0.0.1:9030' && !environment.Production) {
      const applicationRef = moduleRef.injector.get(ApplicationRef);
      const componentRef = applicationRef.components[0];
      enableDebugTools(componentRef);
      console.log('Angular Profiler active');
    }
  })
  .catch(err => console.log(err));
